import styled from "styled-components";

export const WrapperFiles = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    /* width: 100%; */
    height: fit-content;
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;
    padding: 24px;
    overflow-x: auto;

    span {
        font-size: 14px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceTextGray};
    }

    .file {
        display: flex;
        gap: 8px;
        /* width: 100%; */
        height: 56px;
        color: ${({ theme }) => theme.colors.interfaceText500};
        font-weight: 400;

        .file-details{
            display: flex;
            justify-content: space-between;
            width: 100%;
            border: 2px solid ${({ theme }) => theme.colors.interfacePure100};
            border-radius: 8px;
            padding: 16px;

            &.highlight {
                background-color: ${({ theme }) => theme.colors.secondaryPool100};
            }

            .icon-title {
                display: flex;
                align-items: center;
                gap: 18px;
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.interfaceGray400};

                .icon-file {
                    width: 20px;
                    height: 20px;
                }

                .title-file {
                    max-width: 350px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .date-trash {
                display: flex;
                align-items: center;
                gap: 40px;

                .date {
                    font-weight: 500;
                    color: ${({ theme }) => theme.colors.interfaceText300};
                }

                .icon-trash {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                    svg {
                        width: 100%;
                        height: 100%;
                        path {
                            fill: ${({ theme }) => theme.colors.primaryRed400};
                        }
                    }
                }
            }

        }

        .download {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            border-radius: 8px;
            cursor: pointer;
            transition: all .3s;
            &:hover {
                background-color: ${({ theme }) => theme.colors.interfaceText100};
            }
            
            .spinner {
                animation: spin 1s linear infinite;
            }
        }

        &.last {
            .file-details {
                border-color: ${({ theme }) => theme.colors.interfaceGray400};
            }
        }
    }

    .add {
        display: flex;
        align-items: center;
        gap: 20px;
        height: 56px;
        padding: 16px;
        border: 2px dotted ${({ theme }) => theme.colors.primaryRed400};
        color: ${({ theme }) => theme.colors.interfaceGray400};
        font-weight: 500;
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        svg {
            path {
                fill: ${({ theme }) => theme.colors.primaryRed400};
            }
        }

        .file-input {
                width: 100%;
                height: 100%;
                color: transparent;
                transition: all .5s;
                border: none;
                padding: 0;
                background: transparent;
                border-radius: 8px;
                position: absolute;
                top: 0;
                left: 0;
            }
            .file-input::-webkit-file-upload-button {
                visibility: hidden;
            }
            .file-input::before {
                content: 'Anexar arquivos';
                color: ${({ theme }) => theme.colors.interfaceGray400};
                display: flex;
                align-items: center;
                justify-content: flex-start;
                border: none;
                padding: 0;
                width: 100%;
                height: 50px;
                outline: none;
                white-space: nowrap;
                -webkit-user-select: none;
                user-select: none;
                cursor: pointer;
                font-weight: 500;
                font-size: 18px;
                padding-left: 60px;
            }
            .file-input:active {
                outline: 0;
            }
    }

    .loading-file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: ${(props: any) => props.theme.colors.white};
        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
        border-radius: 8px;
        padding: 12px 16px;
        height: 48px;
        box-sizing: border-box;
        margin-top: 8px;
        position: relative;
        overflow: hidden;
    }

    .loading-file-info {
        display: flex;
        gap: 12px;
        align-items: center;
        flex: 1;
    }

    .loading-file-name {
        color: ${(props: any) => props.theme.colors.c1a202c};
        font-size: 14px;
        font-weight: 400;
        animation: pulse 1.5s ease-in-out infinite;
    }

    .loading-file-size {
        color: ${(props: any) => props.theme.colors.c6b7280};
        font-size: 12px;
        animation: pulse 1.5s ease-in-out infinite;
    }

    .loading-spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        flex-shrink: 0;
    }

    .spinner {
        width: 16px;
        height: 16px;
        border: 2px solid ${(props: any) => props.theme.colors.ce2e8f0};
        border-top: 2px solid ${(props: any) => props.theme.colors.primaryRed400};
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes pulse {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }
`